import { Component } from '@angular/core';
import { Globals } from '../../globals';
import { CommonService } from '../../services/common.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
})
export class FooterComponent {
  constructor(protected globals: Globals, private commonService: CommonService) {
  }
  year: number = (new Date()).getFullYear();
  version: string = '';
  ngOnInit() {
    this.getLatestVersion();
    this.version = this.commonService.getCookie('app_version') || '';
  }

  getLatestVersion() {
    this.commonService.showLoader();

    this.commonService.getLatestVersion().then(
      (data: any) => {
        this.version = data.data;
        if (this.version) {
          this.commonService.setCookie('app_version', this.version);
        }

        this.commonService.hideLoader();
      },
      (error) => { },
    );
  }


  checkKeyValueInContents(data: any, key: string) {
    let content = data.filter((item: any) => item.key === key);

    if (content.length > 0) {
      return content[0].value;
    } else {
      return null;
    }

  }

}
